<template>
  <div class="invoice-apply">
    <div class="invoice-apply-header">
      <el-form ref="form" label-width="120px" size="small" :model="form">
        <el-row>
          <el-col :span="8">
            <el-form-item label="申请单号" prop="invoiceApplyNo">
              <el-input placeholder="请输入申请单号" v-model="form.invoiceApplyNo"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item label="发佣批次号" prop="batchNo">
              <el-input placeholder="请输入发佣批次号" v-model="form.batchNo"></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item label="发票类型" prop="invoiceType">
              <el-select v-model="form.invoiceType">
                <el-option v-for="(item, index) in invoiceTypesAll" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="开票状态" prop="invoiceApplyStatus">
              <el-select v-model="form.invoiceApplyStatus">
                <el-option v-for="(item, index) in applyStatusAll" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row v-show="unfold">
          <el-col :span="8">
            <el-form-item label="开票类目" prop="invoiceClass">
              <el-input placeholder="请输入开票类目" v-model="form.invoiceClass"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申请方" prop="apply">
              <el-input placeholder="请输入申请方" v-model="form.apply"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="unfold">
          <el-col :span="8">
            <el-form-item label="申请日期" prop="applyTime">
              <el-date-picker v-model="form.applyTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="审核日期" prop="auditTime">
              <el-date-picker v-model="form.auditTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="确认开票日期" prop="comfirmInvoiceTime">
              <el-date-picker
                v-model="form.comfirmInvoiceTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row style="text-align: right;">
          <el-col :span="24">
            <el-form-item style="margin-bottom: 0px;">
              <el-button @click="resetForm()">重置</el-button>
              <el-button type="primary" @click="submitForm()">查询</el-button>
              <!-- <el-button type="text" @click="handleFold()">{{ unfold ? '收起' : '展开' }}</el-button> -->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="invoice-apply-opea">
      <el-button size="small" v-if="!ismanager" @click="addApply()">新增发票申请</el-button>
      <!-- <el-button size="small" @click="setAmount()">设置起开金额</el-button> -->
      <el-button size="small" @click="exportInfo()">导出</el-button>
    </div>
    <el-table size="small" :data="data">
      <el-table-column prop="invoiceApplyNo" label="申请单号" width="150"> </el-table-column>
      <el-table-column label="发票类型" width="180">
        <template slot-scope="scope">
          {{ getInvoiceType(scope.row.invoiceType) }}
        </template>
      </el-table-column>
      <el-table-column prop="invoiceClassName" label="开票类目" width="190"> </el-table-column>
      <el-table-column prop="invoiceAmount" label="开票金额" width="190"> </el-table-column>
      <el-table-column prop="applyProviderName" label="申请方" width="170"> </el-table-column>
      <el-table-column prop="applyRemark" label="申请方留言" width="160"> </el-table-column>
      <el-table-column label="申请时间" width="150">
        <template slot-scope="scope">
          {{ getFormatDate(scope.row.applyTime) }}
        </template>
      </el-table-column>
      <el-table-column label="开票状态" width="120">
        <template slot-scope="scope">
          {{ getApplyApplyStatus(scope.row.invoiceApplyStatus) }}
        </template>
      </el-table-column>
      <el-table-column label="审核时间" width="150">
        <template slot-scope="scope">
          {{ getFormatDate(scope.row.auditTime) }}
        </template>
      </el-table-column>
      <el-table-column label="确认开票时间" width="150">
        <template slot-scope="scope">
          {{ getFormatDate(scope.row.comfirmInvoiceTime) }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="130">
        <template slot-scope="scope">
          <el-button type="text" size="small" v-if="ismanager && scope.row.invoiceApplyStatus === 1" @click="handleAudit(scope.row)">审核</el-button>
          <el-button type="text" size="small" v-else-if="ismanager && scope.row.invoiceApplyStatus === 2" @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button type="text" size="small" v-else @click="handleInfo(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      layout="prev, pager, next"
      :current-page.sync="page.index"
      :page-size="page.size"
      :total="count"
      @current-change="handlePageChange()"
    >
    </el-pagination>
    <add-invoice-apply
      ref="applyRef"
      :invoiceClassList="invoiceClassList"
      @confirm="handleAddInvoiceApply"
      @loadMore="handleLoadMore"
    ></add-invoice-apply>
    <invoice-audit ref="auditRef" @confirm="handleInvoiceAudit"></invoice-audit>
    <invoice-edit ref="editRef" @confirm="handleInvoiceEdit"></invoice-edit>
    <invoice-info ref="infoRef"></invoice-info>
    <!-- <set-invoice-amount ref="amountRef"></set-invoice-amount> -->
  </div>
</template>

<script>
import api from '@/api/api';
import { invoiceTypesAll, applyStatusAll, applyStatus } from '@/utils/enum';
import { parseTime } from '@/utils';
import AddInvoiceApply from './components/addInvoiceApply';
import invoiceAudit from './components/invoiceAudit';
import invoiceEdit from './components/invoiceEdit';
import invoiceInfo from './components/invoiceInfo';
// import SetInvoiceAmount from './components/setInvoiceAmount';

export default {
  name: 'invoiceApply',
  components: {
    AddInvoiceApply,
    invoiceAudit,
    invoiceEdit,
    invoiceInfo,
  },
  data() {
    return {
      invoiceTypesAll,
      applyStatusAll,
      applyStatus,
      unfold: false, // 展开
      form: {
        invoiceApplyNo: '',
        invoiceType: 0,
        invoiceApplyStatus: 0,

        // batchNo: '',
        // apply: '',
        // invoiceClass: '',
        // applyTime: '',
        // auditTime: '',
        // comfirmInvoiceTime: '',
      },

      invoiceClassList: [], // 发票类别
      // 发票数据
      data: [],
      count: 0,
      page: {
        index: 1,
        size: 10,
      },

      classCount: 0,
      classPage: {
        index: 1,
        size: 10,
      },
    };
  },
  computed: {
    ismanager() {
      return this.$store.getters.ismanager;
    },
  },
  created() {
    this.getInvoiceList();
    this.getInvoiceClassList();
  },
  methods: {
    handleFold() {
      this.unfold = !this.unfold;
    },
    submitForm() {
      this.page.index = 1;
      this.getInvoiceList();
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.page.index = 1;
      this.getInvoiceList();
    },
    addApply() {
      this.$refs.applyRef.show();
    },
    // setAmount() {
    //   this.$refs.amountRef.show();
    // },
    handleLoadMore() {
      this.classPage.index += 1;
      this.getInvoiceClassList();
    },
    exportInfo() {
      const params = {
        invoiceApplyNo: this.form.invoiceApplyNo,
        invoiceType: this.form.invoiceType,
        invoiceApplyStatus: this.form.invoiceApplyStatus,
      };
      api.downloadInvoices(params);
    },

    handleAudit(data) {
      this.$refs.auditRef.show(data);
    },
    handleEdit(data) {
      this.$refs.editRef.show(data);
    },
    handleInfo(data) {
      this.$refs.infoRef.show(data);
    },
    handlePageChange() {
      this.getInvoiceList();
    },
    handleInvoiceAudit(data) {
      api
        .postInvoiceAudit({
          params: {
            data,
          },
        })
        .then(() => {
          this.$refs.auditRef.close();
          this.getInvoiceList();
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.message,
          });
        });
    },
    handleInvoiceEdit(data) {
      api
        .editInvoiceTick({
          params: {
            data,
          },
        })
        .then(() => {
          this.$refs.editRef.close();
          this.$message({
            type: 'success',
            message: '发票信息已编辑',
          });
          this.getInvoiceList();
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.tip,
          });
        });
    },
    handleAddInvoiceApply(data) {
      api
        .addInvoiceApply({
          params: {
            data,
          },
        })
        .then(() => {
          this.$refs.applyRef.close();
          this.$message({
            type: 'success',
            message: '发票申请新增成功',
          });
          this.getInvoiceList();
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.message,
          });
        });
    },
    getInvoiceList() {
      const params = Object.assign({}, this.page, this.form);
      params.index -= 1;

      if (params.invoiceType === -1) params.invoiceType = '';

      api
        .getInvoiceList({
          params: {
            params,
          },
        })
        .then((res) => {
          this.data = res.data;
          this.count = res.count || 0;
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.message,
          });
        });
    },

    getInvoiceClassList() {
      const params = {
        invoiceClassStatus: -1,
        serviceItemId: '',
      };
      Object.assign(params, this.classPage);
      params.index -= 1;

      api
        .getInvoiceClassList({
          params: {
            params,
          },
        })
        .then((res) => {
          this.invoiceClassList = res.data;
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.tip,
          });
        });
    },
    handleSetAmount() {},

    getFormatDate(time) {
      return time ? parseTime(new Date(time)) : '';
    },
    getInvoiceType(type) {
      return type ? invoiceTypesAll[type].label : '';
    },
    getApplyApplyStatus(status) {
      // eslint-disable-next-line arrow-parens
      const findStatus = applyStatus.find((item) => item.value === status);
      return findStatus.label || '';
    },
  },
};
</script>

<style lang="less" scoped>
.invoice-apply {
  .invoice-apply-header {
    border: 1px solid #ebeef5;
    padding: 16px;
  }
  .invoice-apply-opea {
    padding: 16px 0px;
    text-align: right;
  }
  /deep/ .el-date-editor--daterange.el-input__inner {
    width: 100%;
  }
  /deep/ .el-select {
    display: block;
  }

  /deep/ .el-pagination {
    text-align: right;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/invoice/invoiceApply.vue